import React, { useContext, Fragment, useState } from 'react';
import LayoutContainer from '../../../LayoutContainer';
import useParagraphSplit from '../../../../hooks/useParagraphSplit';
import { Context } from '../../../../context/AppContext';
import ToggleSection from '../../../ToggleSection';
import './styles.css';

const ReadMore = ({ description, title }) => {
  const {
    media: { desktop, tablet },
  } = useContext(Context);
  const [show, setShow] = useState();

  const paragraph = useParagraphSplit({
    data: description,
    splitLimit: 2,
  });
  const mobileParagraph = useParagraphSplit({
    data: description,
    wordLimit: 60,
  });

  return (
    <div className="About__ReadMore__root">
      <LayoutContainer>
        <div className="About__ReadMore__content">
          <h3 className="About__ReadMore__heading">{title}</h3>
          <div className="About__ReadMore__description">
            {desktop || tablet ? (
              paragraph.map((text, key) => (
                <p
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                  key={key.toString()}
                />
              ))
            ) : (
              <Fragment>
                {!show && (
                  <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: mobileParagraph[0],
                    }}
                  />
                )}
                {mobileParagraph.length > 1 && (
                  <div className="Location__About__readMore">
                    <ToggleSection
                      moreText="Show More"
                      lessText="Show Less"
                      parentSelector=".About__ReadMore__root"
                      onToggle={value => setShow(value)}
                    >
                      <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                          __html: description,
                        }}
                      />
                    </ToggleSection>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </LayoutContainer>
    </div>
  );
};

export default ReadMore;
